import React from 'react';

import { SiteDetail } from 'components/blocks/Site';

const DetailScreen = (props) => {
  return (
    <div className="page-main">
      <SiteDetail />
    </div>
  );
};

export default DetailScreen;
